import { deleteDoc, doc, updateDoc } from "firebase/firestore";
import React from "react";
import { db } from "../../../utils/firebase";
import { collectionNames, routes } from "../../../utils/Constants";
import { useNavigate } from "react-router-dom";
import { GrTrash } from "react-icons/gr";
import { yyyymmdd } from "../../../helpers/yyyymmdd";
import { MdQrCodeScanner } from "react-icons/md";
import moment from "moment";

const SessionItem = ({ session, idx, getSessions }) => {
  const { name, status, timestamp, id, endTimeStamp, startTimeStamp } = session;
  const navigate = useNavigate();
  const copyHandler = () => {
    navigator.clipboard.writeText(`${window.location.origin}/survey?id=${id}`);
    alert("Copied");
  };
  const deleteSession = async () => {
    // if (new Date() > new Date(endDate)) {
    //   return alert("Delete failed, Session still active.");
    // }
    const confirm = window.confirm("Are you sure want to delete this session?");
    if (!confirm) return;
    await deleteDoc(doc(db, collectionNames.SESSIONS, id));
    getSessions();
  };
  const endSession = async (e) => {
    e.stopPropagation();
    const confirm = window.confirm("Are you sure want to end this session?");
    if (!confirm) return;
    const docRef = await updateDoc(doc(db, collectionNames.SESSIONS, id), {
      status: "closed",
      endTimeStamp: new Date()
    }).then(() => {
      getSessions();
    });
  };

  return (
    <div className="w-1/3 m-5 p-3 border border-black  rounded ">
      <div className="flex items-center ">
        <p className="font-semibold  ">{name}</p>
        <div className="flex-1" />
        <MdQrCodeScanner
          onClick={() => navigate(routes.QR_CODE, { state: { sessionId: id } })}
          className="mr-2 cursor-pointer"
          title="Show Qr Code"
        />
        <GrTrash
          onClick={deleteSession}
          color="red"
          className="cursor-pointer"
          title="Delete"
        />
      </div>
      <p
        className={`text-sm ${
          status == "active" ? "text-green-500" : "text-red-500"
        }`}
      >
        {status}
      </p>
      <p className="text-xs mt-1 ">
        Start. Date:{" "}
        {moment(startTimeStamp?.toDate()).format("DD-MM-yyyy hh:mm A")}
      </p>
      <p className="text-xs mt-1 ">
        End. Date:{" "}
        {endTimeStamp &&
          moment(endTimeStamp?.toDate()).format("DD-MM-yyyy hh:mm A")}
      </p>
      <div
        onClick={copyHandler}
        className=" mt-2 text-xs text-gray-500 border rounded border-gray-200 p-1 cursor-pointer"
      >{`${window.location.origin}/survey?id=${id}`}</div>

      <div
        className="flex space-x-3"
        onClick={() => navigate(routes.SESSION_DETAILS, { state: { session } })}
      >
        <p className="mt-3 w-max text-xs underline text-blue-500 cursor-pointer">
          View Surveys
        </p>
        {status == "active" && (
          <p
            onClick={endSession}
            className="mt-3 w-max text-xs underline text-red-500 cursor-pointer"
          >
            End Session
          </p>
        )}
      </div>
    </div>
  );
};

export default SessionItem;
